module.exports = __webpack_public_path__ + "img/茂名市农业农村局.e6f07c7f.png";